import NotificationIndicator from "features/Nav/components/Nav/parts/NotificationIndicator";
import Badge from "hardcover-ui/components/Badge";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import bell from "icons/solid/bell.svg";

import UserMenuItem from "./UserMenuLink";

export default function MenuNotifications() {
  const currentNotificationsCount = useCurrentUser(
    u => u.notificationsCount || 0,
  );

  return (
    <UserMenuItem url="/notifications">
      <div className="relative w-5 h-5 -mt-2 -mr-1">
        <Icon
          icon={bell}
          className="text-gray-400 group-hover/link:text-indigo-300"
        />
        <div className="absolute top-2 -right-1">
          <NotificationIndicator />
        </div>
      </div>
      <Text>Notifications</Text>
      {currentNotificationsCount > 0 ? (
        <Badge className="ml-2" size="sm" variant="warning">
          {currentNotificationsCount.toLocaleString()}
        </Badge>
      ) : (
        <></>
      )}
    </UserMenuItem>
  );
}
